import { gql } from "@apollo/client";

export const SCREENS = gql`
  query Screens(
    $where: ScreenWhereInput
    $take: Int
    $skip: Int
    $like: JSONObject
    $orderBy: [JSONObject]
  ) {
    screens(
      where: $where
      take: $take
      skip: $skip
      like: $like
      orderBy: $orderBy
    ) {
      data {
        id
        description
        status {
          id
          name
          tag
          process {
            id
            name
          }
        }
        currentPublishedVersion {
          id
          versionNumber
          status
        }
        createdBy
        createdDate
        updatedDate
      }
      count
    }
  }
`;

export const SCREEN = gql`
  query Screen($where: ScreenWhereInput) {
    screen(where: $where) {
      id
      description
      status {
        id
        name
        tag
        order
        process {
          id
        }
      }
      currentPublishedVersion {
        id
        versionNumber
        status
        htmlContent
        styleContent
        sourceLocale
        publishedAt
        publishedBy
        bindingManifest {
          id
          slots
          report
        }
        translationTable {
          id
          entries
        }
        states {
          id
          name
          order
          htmlContent
          conditions
          bindingManifest {
            id
            slots
            report
          }
        }
      }
      versions {
        id
        versionNumber
        status
        htmlContent
        styleContent
        previewImageBase64
        externalId
        sourceLocale
        publishedAt
        publishedBy
        bindingManifest {
          id
          slots
          report
        }
        translationTable {
          id
          entries
        }
        states {
          id
          name
          order
          htmlContent
          conditions
          bindingManifest {
            id
            slots
            report
          }
        }
        createdDate
      }
      createdBy
      createdDate
    }
  }
`;

export const SCREEN_VERSION = gql`
  query ScreenVersion($where: ScreenVersionWhereInput) {
    screenVersion(where: $where) {
      id
      versionNumber
      status
      htmlContent
      styleContent
      sourceLocale
      screen {
        id
        status {
          id
          name
        }
      }
      bindingManifest {
        id
        slots
        report
      }
      translationTable {
        id
        entries
      }
      states {
        id
        name
        order
        htmlContent
        conditions
        bindingManifest {
          id
          slots
          report
        }
      }
      publishedAt
      publishedBy
      createdDate
    }
  }
`;

export const FIELD_REGISTRY = gql`
  query FieldRegistry($process: ProcessWhereInput) {
    fieldRegistry(process: $process) {
      key
      collection
      store
      childrenFields {
        key
      }
      fields {
        key
        label
        options
        target
        mode
        type
        required
        defaultRules
        inputConfig
        scoped
      }
    }
  }
`;

export const ACTION_CATALOG = gql`
  query ActionCatalog {
    actionCatalog {
      id
      builtIn
      category
      description
      permissions
      params {
        name
        type
        required
        description
      }
    }
  }
`;

export const SCREEN_GENERATION_JOB = gql`
  query ScreenGenerationJob($id: ID!) {
    screenGenerationJob(id: $id) {
      id
      status
      error
      html {
        html
        css
        slotsAfter
        summary
        states {
          name
          order
          conditions
          conditionField
          conditionValue
          summary
        }
      }
      state {
        name
        order
        htmlContent
        conditions
        slotsAfter
        summary
      }
      proposal {
        targetId
        targetName
        htmlContent
        styleContent
        previousHtmlContent
        previousStyleContent
        slotsBefore
        slotsAfter
        summary
      }
    }
  }
`;

export const SCREEN_COLLECTIONS = gql`
  query ScreenCollections {
    screenCollections {
      name
      fields
    }
  }
`;

const screens = {
  SCREENS,
  SCREEN,
  SCREEN_VERSION,
  FIELD_REGISTRY,
  ACTION_CATALOG,
  SCREEN_GENERATION_JOB,
  SCREEN_COLLECTIONS,
};

export default screens;
